import React, { useCallback, useMemo } from "react";
import moment from "moment";
import { KeyboardTimePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';
export var TimePicker = function (props) {
    var OK = "Speichern";
    var CANCEL = "Abbrechen";
    var INVALID_TIME_MESSAGE = "Ungültiger Zeitpunkt";
    var onTimeChanged = props.onTimeChanged, value = props.value, label = props.label, classes = props.classes, error = props.error, disabled = props.disabled;
    var onChange = useCallback(function (date) { return onTimeChanged((date === null || date === void 0 ? void 0 : date.format("HH:mm")) || ""); }, [onTimeChanged]);
    var momentValue = useMemo(function () {
        return moment(value, "HH:mm");
    }, [value]);
    return (React.createElement(MuiPickersUtilsProvider, { utils: MomentUtils },
        React.createElement(KeyboardTimePicker, { fullWidth: true, ampm: false, mask: "__:__", label: label, placeholder: "__:__", value: momentValue, format: "HH:mm", onChange: onChange, inputVariant: "outlined", keyboardIcon: React.createElement(QueryBuilderIcon, null), className: classes, error: error, invalidDateMessage: INVALID_TIME_MESSAGE, okLabel: OK, cancelLabel: CANCEL, disabled: !!disabled })));
};
TimePicker.defaultProps = {
    disabled: false
};
//# sourceMappingURL=TimePicker.js.map